import {Langue} from '../context'
import {teext} from './textDef'
import React,{useState,useContext} from 'react'

import {basic} from 'basic'

function Text(props:teext.props)
{
  
    const langue=useContext(Langue)
    const {en,fr}=props
    const [className,style]=basic.getBasic(props)
  
    function arrayText(txt:string[])
    {
      
        if(txt.length==1)
            return <>{txt[0]}</>
        return <>
                    <>{txt[0]}</>
                        <>{props.children}</>
                    <>{txt[1]}</>
                </>
    }

    let output;
    if(langue.toLocaleLowerCase()=="en")
    {
        output=arrayText(props.en)
    }else
        output=arrayText(props.fr)

    return <div className={`${className} gtext`} style={{...style}}>
            {output}
           </div>
}

export default React.memo(Text)